import React from 'react';
import { Menu, MenuButton } from '@retail/components';
import { ButtonBase, MenuItem } from '@mui/material';
import { PriceChangeConfigChip } from './PriceChangeConfigChip';
import { NotificationOption } from '@retail/suppliers/types';

interface Props {
  priceChangeConfig: NotificationOption;
  onEditPriceChangeConfig: (priceChangeConfig: NotificationOption) => void;
}

export const PriceChangeNotificationOptionsMenu: React.FC<Props> = ({
  priceChangeConfig,
  onEditPriceChangeConfig,
}) => (
  <Menu>
    {({ onClose }) => (
      <>
        <MenuButton component={ButtonBase}>
          <PriceChangeConfigChip config={priceChangeConfig} />
        </MenuButton>
        <MenuItem
          value="notify"
          onClick={() => {
            onClose();
            onEditPriceChangeConfig('notify');
          }}
        >
          <PriceChangeConfigChip config="notify" />
        </MenuItem>
        <MenuItem
          value="ignore"
          onClick={() => {
            onClose();
            onEditPriceChangeConfig('ignore');
          }}
        >
          <PriceChangeConfigChip config="ignore" />
        </MenuItem>
      </>
    )}
  </Menu>
);
